<main class="container-fluid">
  <section class="sec-main p-0 m-0">
    <div class="row">
      <div class="col-sm-6 p-5 d-flex">
        <div class="m-5 mt-0 p-3">
          <div class="back-button">
            <a href="" class="back-button-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7062 8.11538C15.095 7.72569 15.0947 7.09466 14.7054 6.70538C14.3158 6.31581 13.6842 6.31581 13.2946 6.70538L8.70711 11.2929C8.31658 11.6834 8.31658 12.3166 8.70711 12.7071L13.2946 17.2946C13.6842 17.6842 14.3158 17.6842 14.7054 17.2946C15.0947 16.9053 15.095 16.2743 14.7062 15.8846L10.83 12L14.7062 8.11538Z" fill="black" fill-opacity="0.5"/>
                    </svg>
                Back
            </a>
        </div>
          <div class="welcome">Welcome {{fullName}},</div>
          <div class="account-info">Your account information</div>
          <p class="change-info">To change your account information, please reach out to your contact person within Tata Steel.</p>

          <article>
            <div class="row">
              <div class="company-info col-6">Company</div>
              <div class="col-6"><b>{{user.companyName}}</b></div>
            </div>
            <div class="row my-2">
              <div class="email-info col-6">Work email</div>
              <div class="col-6"><b>{{user.email}}</b></div> 
            </div>
            <div class="row my-2">
              <div class="col-12">
                <hr />
              </div>
            </div>
          </article>
          <div class="personal-details">Manage your personal details</div>
          <p class="personal-details-info">Edit and save your personal details below.</p>
          <article>
            <form [formGroup]="profileForm" (ngSubmit)="onProfileSubmit()">
              <div class="row" >
                <div class="col-6">
                  <label for="fname" class="first-name form-label">First name:</label>
                  @if (firstName?.invalid && (firstName?.dirty || firstName?.touched)) {
                    <small class="mx-2 text-danger">*</small>
                  }
                  <input type="text" class="form-control" id="fname" name="fname" formControlName="firstName" />
                </div>
                <div class="col-6">
                  <label for="lname" class="last-name form-label">Last name:</label>
                  @if (lastName?.invalid && (lastName?.dirty || lastName?.touched)) {
                    <small class="mx-2 text-danger">*</small>
                  }
                  <input type="text" class="form-control" id="lname" name="lname" formControlName="lastName" />
                </div>
              </div>
              <div class="row my-3">
                <div class="col">
                  <label for="phone" class="phone form-label">Phone number:</label>
                  @if (phone?.invalid && (phone?.dirty || phone?.touched)) {
                    <small class="mx-2 text-danger">*</small>
                  }
                  <input type="text" class="form-control" id="phone" name="phone" formControlName="phone" />
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col">
                  <button type="submit" class="save-button btn btn-primary btn-w" [disabled]="!profileForm.valid">Save Changes</button>
                </div>
              </div>
            </form>
          </article>
        </div>
      </div>
      <div class="col-sm-6 main-profile-pic">
      </div>
    </div>
  </section>
</main>
